import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit {
  utilization = false;
  isPrompt: any = false;
  msg: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.isPrompt = this._data?.isPrompt;
    this.msg = this._data?.msg;
    console.log(this.isPrompt, 'is prompt');
    console.log(this.msg, 'msg');
  }
  
  
  close() {
    this.dialogRef.close();
  }

  yes() {
    if (!this._data.isUtilization) {
      this.sharedService.delete(this._data.url, this._data.id).subscribe(
        (res) => {
          if (res.code === 200) {
            this.dialogRef.close('yes');
            this.sharedService.showMessage(res.message);
          } else {
            this.dialogRef.close('yes');
            this.sharedService.showMessage(res.message);
          }
        },
        (err) => {
          this.sharedService.showMessage(err.message);
        }
      );
    } else {
      this.sharedService
        .delete(this._data.deleteIsUtilizedBin, this._data.id)
        .subscribe(
          (res) => {
            if (res.code === 200 && !res.data) {
              // this.dialogRef.close('yes');
              this.sharedService
                .delete(this._data.url, this._data.id)
                .subscribe((res) => {
                  if (res.code === 200) {
                    this.dialogRef.close('yes');
                    this.sharedService.showMessage(res.message);
                  } else {
                    this.sharedService.showMessage(res.message);
                  }
                });

              // this.sharedService.showMessage(res.message);
            } else {
              // this.sharedService.showMessage(res.message);
              this.utilization = true;
              this.dialogRef.close('yes');
              const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                data: {
                  url: this._data.url,
                  id: this._data.id,
                  isUtilization: false,
                  deleteIsUtilizedBin: this._data.deleteIsUtilizedBin,
                  isUtilizationText: true,
                },
                width: '450px',
              });

              dialogRef.afterClosed().subscribe((result) => {
                console.log(`Dialog result: ${result}`);
                debugger;
                if (result != 'no') {
                  this.sharedService.refresh.next(true);
                }
              });
            }
          },
          (err) => {
            this.sharedService.showMessage(err.message);
          }
        );
    }
  }

  no() {
    this.dialogRef.close('no');
  }
}
